import { z } from 'zod';
export const staleLeadsQuerySchema = z.object({
    project_id: z.string().uuid(),
    days: z.coerce.number().int().min(7).max(730).default(90),
});
export const gdprEraseSchema = z.object({
    confirm: z.literal(true),
});
//# sourceMappingURL=dataHealth.js.map